module.exports = __webpack_public_path__ + "img/member.9a5a3b1c.png";